export default [
    {
        path: 'relatorio-consolidado-aplicacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-relatorio-consolidado-aplicacao' */ '@/views/imunizacao/relatorio-consolidado-aplicacao/Index'),
        redirect: 'relatorio-consolidado-aplicacao/index',
        children: [
            {
                name: 'imunizacao-relatorio-consolidado-aplicacao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-relatorio-consolidado-aplicacao' */ '@/views/imunizacao/relatorio-consolidado-aplicacao/List.vue'),
            },
        ],
    },
]